module.exports = __webpack_public_path__ + "img/brand_promise_illustration_card.835f2098.svg";